import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IObjectsControllable, ILinkedPageObjectSpecifiable } from "../../../../documaker/domain/format/objects";

export interface IEmptyAlertAllowBehaviorPropertyEditable {
  emptyAlertAllowBehavior(): IPropertyEditable<IObjectsControllable<ILinkedPageObjectSpecifiable>>;
}

export function instanceOfIEmptyAlertAllowBehaviorPropertyEditable(instance: any): instance is IEmptyAlertAllowBehaviorPropertyEditable {
  return instance
      && instance.emptyAlertAllowBehavior
      && instanceOfIPropertyEditable<IObjectsControllable<ILinkedPageObjectSpecifiable>>(instance.emptyAlertAllowBehavior());
}
